import useFlightBookingStore from '@/lib/useFlightBookingStore';
import React from 'react'
import ViewDialog from './viewDialog';
import { Eye, Mail, X } from 'lucide-react';
import EmailFlightInfoBar from "./emailFlightInfoBar";
import Image from 'next/image';
import Whatsapp from './whatsapp';

const ShareFlightInfoBar = () => {
    const {
        setIsViewOpen,
        isViewOpen,
        viewData,
        setViewData,
        isEmailOpen,        // Add these new state items
        setIsEmailOpen, 
        isWhatsAppOpen,
        setIsWhatsAppOpen,
      }: any = useFlightBookingStore();

      const handleClick = (type: 'view' | 'email' | 'whatsapp') => {
        switch (type) {
            case 'view':
                setIsViewOpen(!isViewOpen);
                if (isViewOpen) setViewData([]);
                break;
            case 'email':
                setIsEmailOpen(!isEmailOpen);
                break;
            case 'whatsapp':
                setIsWhatsAppOpen(!isWhatsAppOpen);
                break;

        }
    };;

    return (
        <div className="flex justify-end gap-2">
            {isViewOpen && <ViewDialog/>}
            {isEmailOpen && <EmailFlightInfoBar/>}
            {isWhatsAppOpen && <Whatsapp/>}
            
            
           {(isViewOpen || isEmailOpen || isWhatsAppOpen) ? (
                <button onClick={() => {
                    if (isViewOpen) {
                        setIsViewOpen(false);
                        setViewData([]);
                    }
                    if (isEmailOpen) {
                        setIsEmailOpen(false);
                        setViewData([]);
                    }
                    if (isWhatsAppOpen) {
                        setIsWhatsAppOpen(false);
                        setViewData([]);
                    }
                }}>
                    <X className="w-4 text-primary"/>
                </button>) :
            <div className='flex items-center justify-center gap-2'>
           <button 
                onClick={() => handleClick('email')}
                className="flex items-center gap-2 text-sm text-primary"
            >
                <Mail className="w-4" />
                <span className='hidden md:block'>Email</span>
            </button>

            {/* View Button */}
            <button 
                onClick={() => handleClick('view')}
            >
                    <p className="flex items-center gap-2 text-sm text-primary">
                        <Eye className="w-4" />
                        <span className='hidden md:block'>View</span>
                    </p>
            </button>
            <button 
                onClick={() => handleClick('whatsapp')}
            >
                    <p className="flex items-center gap-2 text-sm text-green-500">
                        <Image src={"/whatsapp.svg"} width={15} height={8} alt='whatsapp_svg'/>
                        <span className='hidden md:block'>Whatsapp</span>
                    </p>
            </button>
           </div>}
        </div>
    )
}

export default ShareFlightInfoBar